import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const CheckboxIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.333 1.917H4.667a2.75 2.75 0 0 0-2.75 2.75v14.666a2.75 2.75 0 0 0 2.75 2.75h14.666a2.75 2.75 0 0 0 2.75-2.75V4.667a2.75 2.75 0 0 0-2.75-2.75M4.667 1A3.667 3.667 0 0 0 1 4.667v14.666A3.667 3.667 0 0 0 4.667 23h14.666A3.667 3.667 0 0 0 23 19.333V4.667A3.667 3.667 0 0 0 19.333 1z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
